var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiGenerationLoaderIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 105,
    viewBox: "0 0 101 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3973 36.8899C103.375 54.7919 97.6314 73.3642 81.644 87.1497C65.6566 101.031 39.4258 110.126 21.7152 99.2121C4.00463 88.3943 -5.18573 57.3767 3.0473 34.9752C11.2803 12.4779 36.9368 -1.49914 57.4236 0.128324C78.0062 1.75579 93.5149 19.0835 98.3973 36.8899Z",
    fill: "#011E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_7052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9115 38.4106H64.5951V76.9679H57.9115V70.3325C54.5852 75.4241 49.7356 77.9738 43.3862 77.9738C38.0081 77.9738 33.4151 76.0011 29.6225 72.0713C25.8299 68.1415 23.9336 63.3462 23.9336 57.6932C23.9336 52.0402 25.8299 47.2449 29.6225 43.3073C33.4151 39.3775 38.0081 37.4048 43.3862 37.4048C49.7356 37.4048 54.5852 39.9545 57.9115 45.0461V38.4106ZM44.2333 71.5021C48.1269 71.5021 51.3832 70.1765 53.9945 67.5255C56.6058 64.8744 57.9115 61.5996 57.9115 57.6932C57.9115 53.7868 56.6058 50.5041 53.9945 47.8609C51.3832 45.2098 48.1191 43.8843 44.2333 43.8843C40.3474 43.8843 37.161 45.2098 34.5497 47.8609C31.9384 50.5119 30.625 53.7946 30.625 57.6932C30.625 61.5918 31.9307 64.8822 34.5497 67.5255C37.161 70.1765 40.3941 71.5021 44.2333 71.5021Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7213 35.0111C70.439 35.0111 69.3665 34.5745 68.4961 33.7012C67.6179 32.8279 67.1904 31.7753 67.1904 30.5433C67.1904 29.3114 67.6256 28.2431 68.4961 27.3387C69.3665 26.442 70.439 25.9897 71.7213 25.9897C73.0037 25.9897 73.9984 26.442 74.8689 27.3387C75.7471 28.2431 76.1745 29.3036 76.1745 30.5433C76.1745 31.7831 75.7393 32.8279 74.8689 33.7012C73.9984 34.5823 72.9493 35.0111 71.7213 35.0111Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0245 38.4106H68.3408V76.9679H75.0245V38.4106Z",
    fill: "#B8EF36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_7052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.2414,
    height: 51.9841,
    fill: "white",
    transform: "translate(23.9336 25.9897)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerationLoaderIc);
export default __webpack_public_path__ + "static/media/ai_generation_loader_ic.d8fb186b069feb862fb3482f420b5a4d.svg";
export { ForwardRef as ReactComponent };